import {
	Promotion as PromotionType
} from '../../store/data/promotions/types';

/**
 * Represents PromotionModel
 */
class PromotionModel {
	promotion: PromotionType;

	/**
	 * @constructor
	 * @param {PromotionType} promotion - promotion
	 */
	constructor(promotion: PromotionType) {
		this.promotion = promotion;

		return {
			...this.promotion,
			getPromotionId: this.getPromotionId.bind(this),
			getCalloutMessagePLP: this.getCalloutMessagePLP.bind(this),
			getCalloutMessage: this.getCalloutMessage.bind(this)
		} as unknown as PromotionModel;
	}

	/**
	 * Returns promotion Id
	 * @returns {String} promotion id
	 */
	getPromotionId() {
		return this.promotion?.id;
	}

	/**
	 * Returns plp callout message
	 * @returns {String} callout message for PLP
	 */
	getCalloutMessagePLP() {
		return this.promotion?.c_calloutMessagePLP;
	}

	/**
	 * Returns callout message
	 * @return {String} callout message
	 */
	getCalloutMessage() {
		return this.promotion?.calloutMsg;
	}
}

export default PromotionModel;